import { useState } from "react";
import { useMutation } from "react-query";
import ManageBlogForm from "../forms/ManageBlogsForm/ManageBlogForm";
import { useAppContext } from "../contexts/AppContext";
import * as apiClient from "../api-client";
import { useParams, useNavigate } from "react-router-dom";

const EditBlog = () => {
  const { showToast } = useAppContext();
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [isSaving, setSaving] = useState(false);

  const { mutate, isLoading } = useMutation(apiClient.updateBlogById, {
    onSuccess: () => {
      showToast({ message: "Blog Updated!", type: "SUCCESS" });
      setSaving(false); // Reset saving state
      navigate("/my-blogs");
    },
    onError: (error: any) => {
      showToast({ message: `Error Updating Blog: ${error.message}`, type: "ERROR" });
      setSaving(false); // Reset saving state
    },
  });

  const handleSave = (blogFormData: FormData) => {
    if (!slug) {
      showToast({ message: "Slug is missing for update", type: "ERROR" });
      setSaving(false); // Reset saving state
      return;
    }
    blogFormData.append("slug", slug);
    mutate(blogFormData);
  };

  return <ManageBlogForm onSave={handleSave} isLoading={isLoading} isSaving={isSaving} setSaving={setSaving} />;
};

export default EditBlog;
